import { render } from "./DiscountMethod.vue?vue&type=template&id=16961995&scoped=true"
import script from "./DiscountMethod.vue?vue&type=script&lang=js"
export * from "./DiscountMethod.vue?vue&type=script&lang=js"

import "./DiscountMethod.vue?vue&type=style&index=0&id=16961995&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16961995"]])

export default __exports__